import { globeStaticMapStyles, staticMapStyles } from './mapStyles';

const getLanguageCode = (siteId) => {
  switch (siteId) {
    case 3:
      return 'no';
    case 11:
      return 'da';
    case 15:
      return 'fi';
    default:
      return 'sv';
  }
};

export const getGoogleImageUrl = (itemContent, imageSize, isGlobe, siteId) => {
  const { name, position, extent } = itemContent;
  const { latitude, longitude } = position;
  let url = 'https://maps.googleapis.com/maps/api/staticmap?';
  url += `markers=color:red|label:${name}|${latitude},${longitude}`;

  if (extent?.radius) {
    extent.northEast = {
      latitude: latitude + extent.radius,
      longitude: longitude + extent.radius,
    };
    extent.southWest = {
      latitude: latitude - extent.radius,
      longitude: longitude - extent.radius,
    };
  }

  if (extent) {
    url += extent.northEast
      ? `&visible=${extent.northEast.latitude},${extent.northEast.longitude}`
      : '';
    url += extent?.southWest
      ? `&visible=${extent.southWest.latitude},${extent.southWest.longitude}`
      : '';
  } else {
    url += '&zoom=2';
  }
  url += '&scale=2';
  url += `&size=${imageSize}`;
  url += `&language=${getLanguageCode(parseInt(siteId || 1, 10))}`;
  staticMapStyles.forEach((mapStyle) => {
    url += `&style=${mapStyle}`;
  });
  if (isGlobe) {
    globeStaticMapStyles.forEach((mapStyle) => {
      url += `&style=${mapStyle}`;
    });
  }
  url += '&key=AIzaSyAohsWLZ2CiYPc9UVAb23chczACklSGMZ0';
  return url;
};
